export const SUBCATEGORY_GET_ALL_REQUESTED = 'SUBCATEGORY_GET_ALL_REQUESTED';
export const SUBCATEGORY_GET_ALL_SUCCEEDED = 'SUBCATEGORY_GET_ALL_SUCCEEDED';
export const SUBCATEGORY_GET_ALL_FAILED = 'SUBCATEGORY_GET_ALL_FAILED';

export const SUBCATEGORY_GET_SUBCATEGORIES_HOME_REQUESTED = 'SUBCATEGORY_GET_SUBCATEGORIES_HOME_REQUESTED';
export const SUBCATEGORY_GET_SUBCATEGORIES_HOME_SUCCEEDED = 'SUBCATEGORY_GET_SUBCATEGORIES_HOME_SUCCEEDED';
export const SUBCATEGORY_GET_SUBCATEGORIES_HOME_FAILED = 'SUBCATEGORY_GET_SUBCATEGORIES_HOME_FAILED';
